
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {DashboardProps} from "types/props-obj/DashboardProps";

const initialState: DashboardProps = {
    apiEndPoint: "dashboard",
    
    data: [],
  
};

const dashboard = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
       
       

        // GET Items
        setItemsSuccess(state, action) {
            state.data = action.payload;
            
        },

        // ADD Item
      


        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
       
    }
});


export default dashboard.reducer;

function getApiEndPoint(){
    return store.getState().dashboard.apiEndPoint
}

export const { setApiEndPoint } = dashboard.actions;
export function getDashboardData(params:any={}) {
    return async () => {
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(dashboard.actions.setItemsSuccess(response.data));
        } catch (error) {
            // dispatch(dashboard.actions.hasError(error));
        }
    };
}

